import Typography from "@material-ui/core/Typography";
import React, { ReactNode } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";

interface TitleRowParams {
  prefix?: ReactNode;
  title: ReactNode;
  suffix?: any;
  titleVariant?: Variant;
  classes?: {
    titleText: string;
    title: string;
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    prefix: {
      marginRight: theme.spacing(1)
    },
    suffix: {
      marginLeft: theme.spacing(1),
      flex: "1 0"
    }
  })
);

export const TitleRow = (props: TitleRowParams) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {props.prefix && <span className={classes.prefix}>{props.prefix}</span>}
      <Typography
        variant={props.titleVariant || "h4"}
        className={props.classes && props.classes.title}
      >
        <span className={props.classes && props.classes.titleText}>
          {props.title}
        </span>
      </Typography>
      {props.suffix && <span className={classes.suffix}>{props.suffix}</span>}
    </div>
  );
};
